import type { ComponentChildren } from "preact";
import { useId } from "preact/hooks";

export interface SectionProps {
  title: string;
  /** Right side of the heading (counters, badges). */
  aside?: ComponentChildren;
  children: ComponentChildren;
}

/** Titled block of the loadout editor: title, hairline, then the aside (counters, badges) on the right. */
export function Section({ title, aside, children }: SectionProps) {
  const headingId = useId();
  return (
    <section class="loadouts__sec" aria-labelledby={headingId}>
      <h2 id={headingId} class="loadouts__h">
        <span>{title}</span>
        <span class="loadouts__rule" aria-hidden="true" />
        {aside}
      </h2>
      {children}
    </section>
  );
}

export interface CounterProps {
  /** Dim caption in front of the digits. */
  label?: string;
  value: number;
  /** Shown as "value / max". */
  max?: number;
}

/** LCD readout for the header of a section or block ("Weapon level 3", "2 / 3"). */
export function Counter({ label, value, max }: CounterProps) {
  return (
    <span class="loadouts__count">
      {label}
      <span class="loadouts__lcd">{value}</span>
      {max !== undefined && (
        <>
          <span class="loadouts__of">/</span>
          <span class="loadouts__lcd">{max}</span>
        </>
      )}
    </span>
  );
}
